import React from 'react'
import '../../styles/Expertise/ExpertiseAmiante.css'
import expertiseAmianteSection1 from '../../assets/expertise/expertise-amiante-section1.jpg'
import { Fade } from 'react-awesome-reveal'
import { Accordion, Col, Row } from 'react-bootstrap'
import expertiseAmianteSection2 from '../../assets/expertise/expertise-amiante-section2.jpg'
import expertiseAmianteSection3 from '../../assets/expertise/expertise-amiante-section3.jpg'
import AccordionText from '../Utils/AccordionText'
import { BrowserView, MobileView } from 'react-device-detect'
import { Helmet } from 'react-helmet'

function ExpertiseAmiante() {

    const section2AccordionData = [
        {
            title: "Objectif",
            text: "L’objectif principal du diagnostic amiante avant travaux ou démolition est d’identifier la présence d’amiante dans les matériaux et produits susceptibles d’être dérangés ou démolis. Ceci permet de prévoir les mesures de sécurité adéquates pour éviter l’exposition aux fibres d’amiante, reconnues pour leurs effets nocifs sur la santé (amiante, cancers du poumon et de la plèvre, etc.)."
        }, {
            title: "Cadre légal",
            text: "Le diagnostic amiante avant travaux est requis par le Code du travail pour tout bâtiment construit avant le 1er juillet 1997, avant la réalisation de travaux de rénovation, de maintenance ou d’aménagement. Le diagnostic avant démolition est quant à lui obligatoire pour tous les bâtiments construits avant cette date, déterminant de leur destination ou usage futur."
        }, {
            title: "Méthodologie",
            text: <ul><li>Repérage amiante : Un opérateur de repérage certifié réalise une inspection visuelle et des prélèvements de matériaux et produits susceptibles de contenir de l’amiante.</li><li>Analyse en laboratoire : Les échantillons sont analysés en laboratoire pour confirmer ou infirmer la présence d’amiante.</li><li>Rapport de diagnostic : Un rapport détaillé est fourni, indiquant les matériaux amiantés présents, leur localisation, leur état de conservation, et les recommandations pour la gestion du risque amiante (retrait, confinement, surveillance).</li></ul>
        }
    ]

    const section5Accordion1Data = [
        {
            title: "Prise de contact",
            text: "Communiquez avec E5M Diagnostics pour discuter de votre projet et définir les besoins spécifiques en matière de diagnostic.",
        }, {
            title: "Évaluation préliminaire",
            text: "E5M Diagnostics réalise une première évaluation pour déterminer l’étendue des investigations nécessaires.",
        }, {
            title: "Intervention sur site",
            text: "Nos diagnostiqueurs certifiés procédent à l’inspection détaillée des zones concernées par les travaux ou la démolition, exécutant des prélèvements si nécessaire.",
        }, {
            title: "Rapport de diagnostic",
            text: "E5M Diagnostics vous fournit un rapport complet indiquant la présence ou non d’amiante, la localisation des matériaux amiantés, et les recommandations pour la gestion du risque amiante.",
        }
    ]

    const section5Accordion2Data = [
        {
            title: "Contexte",
            text: "Les HAP sont des composés chimiques présents naturellement dans le charbon et le pétrole brut et peuvent se retrouver dans les enrobés bitumineux utilisés pour les chaussées. Leur manipulation, notamment lors de travaux de réfection routière, peut présenter des risques pour la santé.",
        }, {
            title: "Objectif",
            text: "L’évaluation des HAP vise à identifier et quantifier la présence de ces composés dans les enrobés bitumineux avant le début des travaux de rénovation ou de démolition impliquant ces matériaux.",
        }, {
            title: "Méthodologie",
            text: <ul><li>Prélèvement d’échantillons : Des échantillons de l’enrobé sont prélevés à différents endroits du site concerné.</li><li>Analyse en laboratoire : Les échantillons sont analysés pour déterminer la concentration en HAP.</li><li>Rapport d’évaluation : Le rapport final indique les concentrations en HAP trouvées et propose des recommandations pour la manipulation sécuritaire des matériaux concernés.</li></ul>,
        }
    ]

    return (

        <>
            <Helmet>
                <meta name="title" content="Diagnostic Amiante avant travaux/démolition - E5M Diagnostics" />
                <meta name="description" content="Diagnostic Amiante avant travaux/démolition sur Paris et Île-de-France lors de la vente ou de la mise en location de vos biens immobiliers." />
                <meta property="og:title" content="Diagnostic Amiante avant travaux/démolition - E5M Diagnostics" />
                <meta property="og:description" content="Diagnostic Amiante avant travaux/démolition sur Paris et Île-de-France lors de la vente ou de la mise en location de vos biens immobiliers." />
                <meta property="og:url" content="https://www.e5mdiagnostics.fr/diagnostic-amiante-avant-travaux" />
                <link rel="canonical" href="https://www.e5mdiagnostics.fr/diagnostic-amiante-avant-travaux" />
            </Helmet>

            <BrowserView>
                <div id='expertiseAmiante'>
                    <div id='header'>
                        <div id='expertiseAmianteHeader' className='headerBackground'>
                            <Fade direction={'down'} duration={500}>
                                <div id='headerFilter'>
                                    <h1 id='headerFilterTitle'>Diagnostic Amiante</h1>
                                </div>
                            </Fade>
                        </div>
                    </div>
                    <Row id='expertiseAmianteSection1'>
                        <Col>
                            <Fade direction={'left'} duration={500}>
                                <div id='expertiseAmianteSection1Left'>
                                    <h1 className='sectionTitle'>Qu'est-ce que le diagnostic amiante avant travaux/démolition ?</h1>
                                    <div className='sectionText'>
                                        Les diagnostics amiante avant travaux (DAT) et avant démolition sont des évaluations obligatoires destinées à protéger la santé des travailleurs et des occupants d’un bâtiment contre les risques liés à l’inhalation de fibres d’amiante lors de
                                        travaux ou de la démolition de immeubles. Ces diagnostics sont complétés, dans certains cas, par une évaluation des Hydrocarbures Aromatiques Polycycliques (HAP), notamment dans le cadre de travaux concernant des enrobés bitumineux. Voici une
                                        présentation détaillée de ces diagnostics.
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                        <Col>
                            <Fade direction={'left'} duration={500} delay={100}>
                                <div id='expertiseAmianteSection1Right'>
                                    <img src={expertiseAmianteSection1} id='expertiseAmianteSection1Image' alt='expertise-amiante-section1' />
                                </div>
                            </Fade>
                        </Col>
                    </Row>
                    <Row id='expertiseAmianteSection2'>
                        <Col sm={6}>
                            <div id='expertiseAmianteSection2Left'>
                                <Fade direction={'right'} duration={500}>
                                    <img src={expertiseAmianteSection2} className='expertiseAmianteSection2Image' alt='expertise-amiante-section2' />
                                </Fade>
                            </div>
                        </Col>
                        <Col sm={6}>
                            <Fade direction={'right'} duration={500} delay={100}>
                                <div id='expertiseAmianteSection2Right'>
                                    <h1 className='sectionTitle'>Diagnostic amiante avant travaux/démolition</h1>
                                    <div className='sectionAccordion'>
                                        <Accordion>
                                            {section2AccordionData.map((item, index) => {
                                                return (
                                                    <AccordionText
                                                        key={index}
                                                        indexKey={index}
                                                        header={item.title}
                                                        body={item.text}
                                                    />
                                                )
                                            })}
                                        </Accordion>
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                    </Row>
                    <Row id='expertiseAmianteSection3'>
                        <Col>
                            <Fade direction={'left'} duration={500}>
                                <div id='expertiseAmianteSection3Left'>
                                    <h1 className='sectionTitle'>Qui doit demander la réalisation de ce diagnostic ?</h1>
                                    <div className='sectionText'>
                                        La responsabilité de faire réaliser un DAAT ou un DAAD incombe au maître d’ouvrage, c’est-à-dire à la personne physique ou morale pour le compte de lequel les travaux sont effectués. Cela inclut les propriétaires de bâtiments, les entrepreneurs,
                                        les promoteurs immobiliers ou toute entité engagée dans la rénovation ou la démolition d’un bâtiment construit avant le 1er juillet 1997.
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                        <Col>
                            <Fade direction={'left'} duration={500} delay={100}>
                                <div id='expertiseAmianteSection3Right'>
                                    <img src={expertiseAmianteSection3} id='expertiseAmianteSection3Image' alt='expertise-amiante-section3' />
                                </div>
                            </Fade>
                        </Col>
                    </Row>
                    <div id='expertiseAmianteSection4'>
                        <Fade direction={'right'} duration={500}>
                            <h1 className='sectionTitle'>Quand faut-il demander un DAAT-DAAD ?</h1>
                            <div className='sectionText'>
                                La réalisation d’un DAAT ou d’un DAAD est obligatoire avant l’initiation de tout projet de travaux dans un bâtiment susceptible de contenir de l’amiante, ou avant la démolition de tout ou partie d’un bâtiment. Il est crucial de planifier ce diagnostic
                                en amont pour éviter tout retard dans le projet et assurer la mise en place des mesures de sécurité nécessaires.
                            </div>
                        </Fade>
                    </div>
                    <Row id='expertiseAmianteSection5'>
                        <Col>
                            <Fade direction={'left'} duration={500}>
                                <div id='expertiseAmianteSection5Left'>
                                    <h1 className='sectionTitle'>Comment faire réaliser un diagnostic amiante avant travaux ou avant démolition ?</h1>
                                    <div className='sectionText'>
                                        Pour faire réaliser un DAAT ou un DAAD, il est impératif de s’adresser à un professionnel certifié, tel que E5M Diagnostics, qui dispose de l’expertise et des qualifications nécessaires pour effectuer ces diagnostics conformément à la
                                        réglementation en vigueur.
                                    </div>
                                    <div className='sectionText'>
                                        Voici les étapes clés avec E5M Diagnostics :
                                    </div>
                                    <div id='expertiseAmianteSection5Accordion' className='sectionAccordionDark'>
                                        <Accordion>
                                            {section5Accordion1Data.map((item, index) => {
                                                return (
                                                    <AccordionText
                                                        key={index}
                                                        indexKey={index}
                                                        header={item.title}
                                                        body={item.text}
                                                    />
                                                )
                                            })}
                                        </Accordion>
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                        <Col>
                            <Fade direction={'left'} duration={500}>
                                <div id='expertiseAmianteSection5Right'>
                                    <h1 className='sectionTitle'>Diagnostic Hydrocarbures Aromatiques Polycycliques (HAP)</h1>
                                    <div id='expertiseAmianteSection5Accordion' className='sectionAccordionDark'>
                                        <Accordion>
                                            {section5Accordion2Data.map((item, index) => {
                                                return (
                                                    <AccordionText
                                                        key={index}
                                                        indexKey={index}
                                                        header={item.title}
                                                        body={item.text}
                                                    />
                                                )
                                            })}
                                        </Accordion>
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                    </Row>
                    <div id='expertiseAmianteSection6'>
                        <Fade direction={'right'} duration={500}>
                            <h1 className='sectionTitle'>Prévention des risques sanitaires</h1>
                            <div className='sectionText'>
                                Les diagnostics amiante avant travaux/démolition et l’évaluation des HAP sont des étapes indispensables pour la prévention des risques sanitaires lors de la manipulation de matériaux potentiellement dangereux. Ils nécessitent l’intervention d’experts
                                certifiés pour garantir la sécurité des travailleurs et du public, ainsi que la conformité à la réglementation en vigueur. Ces diagnostics permettent d’établir un plan de gestion du risque adapté, comprenant des mesures de protection, de confinement
                                ou de retrait des matériaux dangereux.
                            </div>
                        </Fade>
                    </div>
                </div>
            </BrowserView>

            <MobileView>
                <div id='expertiseAmiante'>
                    <div id='header'>
                        <div id='expertiseAmianteHeader' className='headerBackground'>
                            <Fade direction={'down'} duration={500}>
                                <div id='headerFilterMobile'>
                                    <h1 id='headerFilterTitleMobile'>Diagnostic Amiante</h1>
                                </div>
                            </Fade>
                        </div>
                    </div>
                    <div id='expertiseAmianteSection1Mobile' className='sectionDarkMobile'>
                        <Fade direction={'left'} duration={500}>
                            <h1 className='sectionTitleMobile'>Qu'est-ce que le diagnostic amiante avant travaux/démolition ?</h1>
                            <div className='sectionTextMobile'>
                                Les diagnostics amiante avant travaux (DAT) et avant démolition sont des évaluations obligatoires destinées à protéger la santé des travailleurs et des occupants d’un bâtiment contre les risques liés à l’inhalation de fibres d’amiante lors de
                                travaux ou de la démolition de immeubles. Ces diagnostics sont complétés, dans certains cas, par une évaluation des Hydrocarbures Aromatiques Polycycliques (HAP), notamment dans le cadre de travaux concernant des enrobés bitumineux. Voici une
                                présentation détaillée de ces diagnostics.
                            </div>
                        </Fade>
                        <Fade direction={'left'} duration={500} delay={100}>
                            <img src={expertiseAmianteSection1} id='expertiseAmianteSection1ImageMobile' alt='expertise-amiante-section1' />
                        </Fade>
                    </div>
                    <div id='expertiseAmianteSection2Mobile'>
                        <Fade direction={'right'} duration={500}>
                            <img src={expertiseAmianteSection2} className='expertiseAmianteSection2ImageMobile' alt='expertise-amiante-section2' />
                        </Fade>
                        <Fade direction={'right'} duration={500} delay={100}>
                            <h1 className='sectionTitleMobile'>Diagnostic amiante avant travaux/démolition</h1>
                            <div className='sectionAccordionMobile'>
                                <Accordion>
                                    {section2AccordionData.map((item, index) => {
                                        return (
                                            <AccordionText
                                                key={index}
                                                indexKey={index}
                                                header={item.title}
                                                body={item.text}
                                            />
                                        )
                                    })}
                                </Accordion>
                            </div>
                        </Fade>
                    </div>
                    <div id='expertiseAmianteSection3Mobile' className='sectionDarkMobile'>
                        <Fade direction={'left'} duration={500}>
                            <h1 className='sectionTitleMobile'>Qui doit demander la réalisation de ce diagnostic ?</h1>
                            <div className='sectionTextMobile'>
                                La responsabilité de faire réaliser un DAAT ou un DAAD incombe au maître d’ouvrage, c’est-à-dire à la personne physique ou morale pour le compte de lequel les travaux sont effectués. Cela inclut les propriétaires de bâtiments, les entrepreneurs,
                                les promoteurs immobiliers ou toute entité engagée dans la rénovation ou la démolition d’un bâtiment construit avant le 1er juillet 1997.
                            </div>
                        </Fade>
                        <Fade direction={'left'} duration={500} delay={100}>
                            <img src={expertiseAmianteSection3} id='expertiseAmianteSection3ImageMobile' alt='expertise-amiante-section3' />
                        </Fade>
                    </div>
                    <div id='expertiseAmianteSection4Mobile'>
                        <Fade direction={'right'} duration={500}>
                            <h1 className='sectionTitleMobile'>Quand faut-il demander un DAAT-DAAD ?</h1>
                            <div className='sectionTextMobile'>
                                La réalisation d’un DAAT ou d’un DAAD est obligatoire avant l’initiation de tout projet de travaux dans un bâtiment susceptible de contenir de l’amiante, ou avant la démolition de tout ou partie d’un bâtiment. Il est crucial de planifier ce diagnostic
                                en amont pour éviter tout retard dans le projet et assurer la mise en place des mesures de sécurité nécessaires.
                            </div>
                        </Fade>
                    </div>
                    <div id='expertiseAmianteSection5Mobile' className='sectionDarkMobile'>
                        <Fade direction={'left'} duration={500}>
                            <h1 className='sectionTitleMobile'>Comment faire réaliser un diagnostic amiante avant travaux ou avant démolition ?</h1>
                            <div className='sectionTextMobile'>
                                Pour faire réaliser un DAAT ou un DAAD, il est impératif de s’adresser à un professionnel certifié, tel que E5M Diagnostics, qui dispose de l’expertise et des qualifications nécessaires pour effectuer ces diagnostics conformément à la
                                réglementation en vigueur.
                            </div>
                            <div className='sectionTextMobile'>
                                Voici les étapes clés avec E5M Diagnostics :
                            </div>
                            <div className='sectionAccordionDark sectionAccordionDarkMobile'>
                                <Accordion>
                                    {section5Accordion1Data.map((item, index) => {
                                        return (
                                            <AccordionText
                                                key={index}
                                                indexKey={index}
                                                header={item.title}
                                                body={item.text}
                                            />
                                        )
                                    })}
                                </Accordion>
                            </div>
                        </Fade>
                        <Fade direction={'left'} duration={500}>
                            <h1 className='sectionTitleMobile'>Diagnostic Hydrocarbures Aromatiques Polycycliques (HAP)</h1>
                            <div className='sectionAccordionDark sectionAccordionDarkMobile'>
                                <Accordion>
                                    {section5Accordion2Data.map((item, index) => {
                                        return (
                                            <AccordionText
                                                key={index}
                                                indexKey={index}
                                                header={item.title}
                                                body={item.text}
                                            />
                                        )
                                    })}
                                </Accordion>
                            </div>
                        </Fade>
                    </div>
                    <div id='expertiseAmianteSection6Mobile'>
                        <Fade direction={'right'} duration={500}>
                            <h1 className='sectionTitleMobile'>Prévention des risques sanitaires</h1>
                            <div className='sectionTextMobile'>
                                Les diagnostics amiante avant travaux/démolition et l’évaluation des HAP sont des étapes indispensables pour la prévention des risques sanitaires lors de la manipulation de matériaux potentiellement dangereux. Ils nécessitent l’intervention d’experts
                                certifiés pour garantir la sécurité des travailleurs et du public, ainsi que la conformité à la réglementation en vigueur. Ces diagnostics permettent d’établir un plan de gestion du risque adapté, comprenant des mesures de protection, de confinement
                                ou de retrait des matériaux dangereux.
                            </div>
                        </Fade>
                    </div>
                </div>
            </MobileView>
        </>

    )

}

export default ExpertiseAmiante